import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { lookupMed } from 'helpers/medicationHelpers';
import { getCurrentUserId, setMedsLoaded } from 'store/storeValtio';
import pencilEdit from 'icons/pencil-edit-24.png';
import { medsCreateState, resetMedsCreateState, createMedsStep } from 'store/storeValtio';
import MedicationName from './MedicationName';
import MedicationBrand from './MedicationBrand';
import MedicationType from './MedicationType';
import MedicationForm from './MedicationForm';
import MedicationStrength from './MedicationStrength';
import MedicationDosage from './MedicationDosage';
import MedicationOften from './MedicationOften';
import MedicationSchedule from './MedicationSchedule';
import MedicationDaily from './MedicationDaily';
import MedicationHourly from './MedicationHourly';
import MedicationWeekly from './MedicationWeekly';
import MedicationWeekDays from './MedicationWeekDays';
import MedicationEveryNDays from './MedicationEveryNDays';
import { updateMedicationInDb } from 'store/localDb';
import chevLeft from 'icons/chevron-left-24.png';

export default function EditMedication(props) {
  const [item, setItem] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [submitting, setSubitting] = useState(false);
  const navigate = useNavigate();
  //const useMCS = useMedsCreateState();

  const params = useParams();
  const medId = params.id;

  //console.log('EditMedication', medId);

  useEffect(() => {
    resetMedsCreateState(null);
    if (medId) {
      const med = lookupMed(medId);
      console.log('med', med);
      medsCreateState.medicationId = med.medicationId;
      medsCreateState.userId = med.userId;
      medsCreateState.labelId = med.labelId;
      medsCreateState.name = med.name;
      medsCreateState.type = med.type;
      medsCreateState.brand = med.brand;
      medsCreateState.orangeId = med.orangeId;
      medsCreateState.form = med.form;
      medsCreateState.dosage = med.dosage;
      medsCreateState.strength = med.strength;
      medsCreateState.schedule = med.schedule;
      medsCreateState.often = med.often;
      medsCreateState.occurance = med.occurance;
      medsCreateState.sortOrder = med.sortOrder;
    }
    console.log('EditMed UE', medsCreateState);
    setLoaded(true);
  },[]);

  //if (!med) return (<></>);

  //const medsHowMuch = ['POWDER', 'LIQUID'].includes(medsCreateState.form);
  //const manyMuch = medsHowMuch ? 'much' : 'many';

  async function update() {
    try {
      setSubitting(true);
      // update med
      const newVals = {
        id: medsCreateState.id,
        userId: medsCreateState.userId,
        labelId: medsCreateState.labelId,
        medicationId: medsCreateState.medicationId,
        name: medsCreateState.name,
        type: medsCreateState.type,
        brand: medsCreateState.brand,
        orangeId: medsCreateState.orangeId,
        description: medsCreateState.description,
        form: medsCreateState.form,
        dosage: medsCreateState.dosage,
        strength: medsCreateState.strength,
        occurance: medsCreateState.occurance,
        often: medsCreateState.often,
        schedule: JSON.parse(JSON.stringify(medsCreateState.schedule)),
        isPaused: medsCreateState.isPaused,
        withMeals: medsCreateState.withMeals,
        sortOrder: medsCreateState.sortOrder
      };
  
      //console.log('updateMed', newVals);
      await updateMedicationInDb(newVals)

      setMedsLoaded(false); // force reload to get ID
      resetMedsCreateState();
      navigate('/');
    } catch (err) {
        console.log('med submit error', err);
    } finally {
        setSubitting(false);
    }
    
  };

  function edit(item) {
    //console.log('edit', medsCreateState);
    setItem(item);
  };

  function nextStep(ns) {
    //console.log('nextStep', ns);
    switch (ns) 
    {
        case createMedsStep.hourly: // daily
            setItem('hourly');
            break;           
        case createMedsStep.daily: // daily
            setItem('daily');
            break;           
        case createMedsStep.weekly: // daily
            setItem('weekdays');
            break;           
        case createMedsStep.weekdays: // daily
            setItem('weekdays');
            break;           
        case createMedsStep.everyndays: // daily
            setItem('everyndays');
            break;           
        case createMedsStep.schedule: // daily
            setItem('schedule');
            break;           
        default:
            setItem(null);
            break;
    }
  }

  function cancel() {
    if (!item) navigate(-1);
    setItem(null);
  }

  let howOften = '';
  // let strength = medsCreateState.strength;
  // let howMany = medsCreateState.dosage;
  // if (medsHowMuch) {
  //   switch (strength) {
  //     case 't':
  //       howMany += ' Tsp';
  //       break;
  //     case 'T':
  //       howMany += ' Tbsp';
  //       break;
  //     case 'ml':
  //       howMany += ' ML';
  //       break;
  //     default:
  //       break;
  //   }
  //   strength = '';
  // }

  if (medsCreateState.often === 'hourly') {
    if (medsCreateState.occurance > 0) howOften = `Every ${medsCreateState.occurance} hour(s)`;
  } else if (medsCreateState.often === 'daily') {
    howOften = `${medsCreateState.occurance} time(s) daily`;
  } else if (medsCreateState.often === 'everyndays') {
    howOften = `Every ${medsCreateState.occurance} days`;
  } else if (medsCreateState.often === 'weekly') {
    howOften = `${medsCreateState.occurance} time(s) per week`;
  } else if (medsCreateState.often === 'asNeeded') {
    howOften = 'As needed';
  } else {
    howOften = 'Not indicated';
  }

  let medType = '';
  switch (medsCreateState.type) {
    case 'S':
      medType = 'Supplement';
      break;
    case 'P':
      medType = 'Prescription';
      break;
    case 'C':
      medType = 'Over the counter';
      break;
    default:
      medType = 'Other';
      break;
  }

  function back() {
    if (item) 
      setItem(null)
    else
      navigate(-1);
  }

  return (
    <div className='mcard'>
      <div className='mcard-screen flex flex-row justify-between h-100'>
        <div className='hover:cursor-pointer' onClick={()=>back()}>
          <img src={chevLeft} alt='' />
        </div>
        <div className='w-full pl-4'>
          Edit Medication
        </div>
      </div>
      { !item &&
      <div className='py-2 flex justify-center min-w-full px-4 phone:px-6 tablet:px-8'>
        <table className='medTable'>
          <tbody className='medTbody'>
            <tr>
              <td> Medication </td>
              <td> {medsCreateState.name} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('name')}/></td>
            </tr>
            <tr>
              <td> Brand </td>
              <td> {medsCreateState.brand} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('brand')}/></td>
            </tr>
            <tr>
              <td> Type </td>
              <td> {medType} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('type')}/></td>
            </tr>
            <tr>
              <td> Form </td>
              <td> {medsCreateState.form} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('form')}/></td>
            </tr>
            <tr>
              <td> Strength </td>
              <td> {medsCreateState.strength} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('strength')}/></td>
            </tr>
            <tr>
              <td> Dosage </td>
              <td> {medsCreateState.dosage} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('dosage')}/></td>
            </tr>
            <tr>
              <td> How Often </td>
              <td> {howOften} </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('often')}/></td>
            </tr>
            <tr>
              <td> Dose Times </td>
              <td>
                {medsCreateState.schedule &&
                  medsCreateState.schedule.map((s, ix) => {
                    return (
                      <div key={ix}>
                        {medsCreateState.schedule[ix]}
                        <br />
                      </div>
                    );
                  })}
              </td>
              <td><img src={pencilEdit} alt='' className="w-6 hover:cursor-pointer" onClick={()=>edit('schedule')}/></td>
            </tr>
          </tbody>
        </table>
      </div>
      }
      { item === 'name' &&
        <MedicationName nextStep={nextStep} />
      }
      { item === 'brand' &&
        <MedicationBrand nextStep={nextStep} />
      }
      { item === 'type' &&
        <MedicationType nextStep={nextStep} />
      }
      { item === 'form' &&
        <MedicationForm nextStep={nextStep} />
      }
      { item === 'strength' &&
        <MedicationStrength nextStep={nextStep} />
      }
      { item === 'dosage' &&
        <MedicationDosage nextStep={nextStep} />
      }
      { item === 'often' &&
        <MedicationOften nextStep={nextStep} />
      }
      { item === 'hourly' &&
        <MedicationHourly nextStep={nextStep} />
      }
      { item === 'daily' &&
        <MedicationDaily nextStep={nextStep} />
      }
      { item === 'schedule' &&
        <MedicationSchedule nextStep={nextStep} />
      }
      { item === 'weekly' &&
        <MedicationWeekly nextStep={nextStep} />
      }
      { item === 'everyndays' &&
        <MedicationEveryNDays nextStep={nextStep} />
      }
      { item === 'weekdays' &&
        <MedicationWeekDays nextStep={nextStep} />
      }

      {!item && 
      <div className='mt-2 flex flex-row justify-around'>
          <button 
            onClick={()=>cancel()} 
            className='mhBtn bg-red-200'>
                Cancel
          </button>
          <button 
            onClick={()=>update()} 
            disabled={submitting}
            className='mhBtn bg-green-200'>
                Update
        </button>
      </div>
      }
    </div>
  );
}
